(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("SSOLoginController", SSOLoginController);

    SSOLoginController.$inject = ['$state', '$stateParams'];

    function SSOLoginController ($state, $stateParams)  { 
        const ref = $stateParams.ref;       
        var provider = '';

        if ($state.current.name.includes('hw_sso_login')) {
            provider = 'hallandwoodhouse';
        } else if ($state.current.name.includes('mcd_sso_login')) {
            provider = 'mcdonalds';
        } else if ($state.current.name.includes('fulham_shores_sso_login')) {
            provider = 'fulham-shores';
        } else if ($state.current.name.includes('mcd_uk_sso_login')) {
            provider = 'mcdonalds';
        } else if ($state.current.name.includes('fuller_sso_login')) {
            provider = 'fullers';
        } else if ($state.current.name.includes('shakeshack_sso_login')) {
            provider = 'shakeShack';
        } else if ($state.current.name.includes('arc_burger_sso_login')) {
            provider = 'arcBurger';
        } else if ($state.current.name.includes('steaknshake_login')) {
            provider = 'steak-and-shake';
        } else if ($state.current.name.includes('connectivity_source_sso_login')) {
            provider = 'connectivity-source';
        } else if ($state.current.name.includes('kfc_sso_login')) {
            provider = 'kfc';
        } else if ($state.current.name.includes('jib_sso_login')) {
            HStorageManager.put({
                storageLevel: 'COOKIES',
                key: 'client_id',
                value: 'jib'
            });
            hLoginManager.reset();
            provider = 'jack-in-the-box';
        } else if ($state.current.name.includes('firmdale_hotels_sso_login')) {
            provider = 'firmdale';
        } else if ($state.current.name.includes('honeygrow_sso_login')) {
            provider = 'honey-grow';
        } else if ($state.current.name.includes('subway_sso_login')) {
            provider = 'subway';
        } else if ($state.current.name.includes('district_taco_sso_login')) {
            provider = 'district-taco';
        }  else if ($state.current.name.includes('free_birds_sso_login')) {
            provider = 'freebirds';
        } else {
            provider = 'Radisson';
        }

        if (!$state.current.name.includes('jib_sso_login')) {
            if (HStorageManager.get({
                storageLevel: 'COOKIES',
                key: 'client_id'
            })) {
                HStorageManager.remove({
                    storageLevel: 'COOKIES',
                    key: 'client_id',
                });
                hLoginManager.reset();
            }
        }

        var self = this;

        self.$onInit = async () => {
            const token = await hLoginManager.getToken();
            if (token) {
                if (ref){
                    window.location.href = decodeURIComponent(ref);
                } else {
                    $state.go('appLayout.harriSH.dashboard');
                }
            }
            else {
                if (ref) {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'sso_login_redirect_url',
                        expiryDays: 1/24,
                        value: ref
                    });
                }
                else {
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'sso_login_redirect_url'
                    });
                }
            }
        }

        self.login = function(){
            hLoginManager.getFederateSignInLink(provider).then(function(redirectUrl){
                window.open(redirectUrl, '_self', 'noopener');
            }, function (err) {
                hLog(provider.toUpperCase(), 'REDIRECT_PAGE', err);
                betterSomethingWentWrong();
            });
        };
        self.loginToTeamLive = function () {
            var origin = environmentsConfig.getTeamLiveOrigin();
            const params = new URLSearchParams();
            params.set('provider', provider);
            if (ref) {
                params.set('ref', ref);
            }
            window.location.href = `${origin}/tl-sso?${params.toString()}`;
        };
    }

})();
